export const UPLOAD_STATUSES = {
  FAILED: 'failed',
  COMPLETED: 'completed',
};
